<template>
  <div class="supervision-empty">
    <div class="img-bg" />
    <div class="empty-text" v-html="content" />
  </div>
</template>

<script>
export default {
  props: {
    content: {
      default: '暂无数据',
      type: String
    }
  }
}

</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';
.supervision-empty {
  margin: 200px auto;
  text-align: center;
  .img-bg {
    width: 160px;
    height: 93px;
    background: url("../imgs/empty-supervision.svg") no-repeat;
    background-size: 160px auto;
    margin: 0 auto;
  }
  .empty-text {
    margin-top: 24px;
    color: @gray-3;
    font-size: 14px;
  }
}
</style>
